import queryString from 'query-string';
import { useSearch } from 'wouter';

interface UseFiltersQueryOptions {
    sort?: string | null;
}

export default function useFiltersQuery({ sort }: UseFiltersQueryOptions = {}): { order?: string } {
    const search = useSearch();

    const { sort: sortParam = sort } = queryString.parse(search);
    // const { id: brandId = null } = brand || {};
    const query: { order?: string } = {};
    if (sortParam !== null) {
        query.order = sortParam as string;
    }

    return query;
}
